// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e5538976","453":"3d02d29c"}[chunkId] + ".chunk.js";
};